import React, { createContext, useContext, useState } from 'react';

// Create the context with a default value of null for better type safety.
const DocumentContext = createContext<{
  documentId: string | null;
  setDocumentId: React.Dispatch<React.SetStateAction<string | null>>;
} | null>(null);

// Create a provider component
export const DocumentProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [documentId, setDocumentId] = useState<string | null>(null);

  return (
    <DocumentContext.Provider value={{ documentId, setDocumentId }}>
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocument = () => {
  const context = useContext(DocumentContext);
  if (!context) {
    throw new Error('useDocument must be used within a DocumentProvider');
  }
  return context;
};

export default DocumentContext;
